module.exports = __webpack_public_path__ + "static/alex-grad-2-9c1ce27da6af95f107d312c8266ae1ba.jpg";